module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kqxIY"))).then(() => module.bundle.root('fThBo'));